/**
 * useProductGroups
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ProductGroupsContext from './product-groups-context'

const useProductGroups = () => {
  const context = useContext(ProductGroupsContext)
  return context
}

export default useProductGroups
